module.exports = __webpack_public_path__ + "img/33900017m-101.asm.258ea09f.jpg";